import React, { useEffect, useMemo, useState } from "react";

const API = process.env.REACT_APP_API_URL || window.location.origin;

export default function Equipment() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const r = await fetch(`${API}/api/equipments`);
                const data = await r.json().catch(() => []);
                setItems(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("Ekipmanlar alınamadı:", error);
                setItems([]);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    const sortedItems = useMemo(() => {
        return [...items].sort((a, b) => a.name.localeCompare(b.name, "tr"));
    }, [items]);

    const getInitial = (name) => {
        if (!name) return "?";
        return name.trim().charAt(0).toUpperCase();
    };

    return (
        <div className="equipmentPage">
            <div className="container">
                <div className="equipmentPageHeader">
                    <h1 className="equipmentPageTitle">Ekipmanlar</h1>
                    <p className="equipmentPageSubtitle">
                        Kahve ekipmanlarımızı inceleyebilirsiniz.
                    </p>
                </div>

                {loading ? (
                    <div className="equipmentEmpty">Yükleniyor...</div>
                ) : sortedItems.length === 0 ? (
                    <div className="equipmentEmpty">Henüz ekipman eklenmemiş.</div>
                ) : (
                    <div className="equipmentGrid">
                        {sortedItems.map((item) => (
                            <div className="equipmentCard" key={item.id}>
                                <div className="equipmentCardMedia">
                                    {item.imageUrl ? (
                                        <img
                                            src={`${API}${item.imageUrl}`}
                                            alt={item.name}
                                            className="equipmentCardImage"
                                        />
                                    ) : (
                                        <div className="equipmentCardFallback">
                                            {getInitial(item.name)}
                                        </div>
                                    )}
                                </div>

                                <div className="equipmentCardBody">
                                    <h3 className="equipmentCardTitle">{item.name}</h3>
                                    <div className="equipmentCardPrice">
                                        ₺{Number(item.price).toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}